import React, { Component } from 'react';
import styled from 'styled-components';
import type { SearchPageQuery } from '@graphql/pages/search.generated';
import type { Locale } from '@lib/locale';
import SearchResultsContainer from '../SearchPage/SearchResultsContainer';
import RenderLayoutViews from '../shared/RenderLayoutViews';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import { apiSearchAlgolia } from '../../../../lib/apiQueries';
import type { PageInjectedProps } from './Page';

type Props = {
  locale: Locale;
  searchPageData: NonNullable<SearchPageQuery['allSearch']> | Record<string, never>;
  searchNavBarData: NonNullable<SearchPageQuery['allNavigationSearchBars']>[number] | Record<string, never>;
  searchQuery: string;
} & Partial<Pick<PageInjectedProps, 'userData' | 'pageStateModifiers'>>;

type State = {
  shopHitsData: unknown[];
  categoryHitsData: unknown[];
  totalNumberOfHits: number | null;
};

const SearchPageContainerDiv = styled.div`
  margin: ${(p) => p.theme.unit(8)} 0 0 0;
`;

const MobileSearchPageContainerDiv = styled.div`
  margin: ${(p) => p.theme.unit(4)} 0 0 0;
`;

class SearchContent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      shopHitsData: [],
      categoryHitsData: [],
      totalNumberOfHits: null,
    };
  }

  UNSAFE_componentWillMount() {
    const { searchQuery, locale } = this.props;

    apiSearchAlgolia(searchQuery, {}, 'shops', locale)
      .then((content: { hits: unknown[]; nbHits: number }) => {
        this.setState({ shopHitsData: content.hits });
        return content.nbHits;
      })
      .then((initialTotalNumber) => apiSearchAlgolia(searchQuery, {}, 'categories', locale)
        .then((content: { hits: unknown[]; nbHits: number }) => {
          this.setState({
            categoryHitsData: content.hits,
            totalNumberOfHits: initialTotalNumber + content.nbHits,
          });
        }))
      .catch((err: unknown) => console.error(err));
  }

  render() {
    const {
      searchPageData,
      searchNavBarData,
      searchQuery,
      locale,
      userData,
      pageStateModifiers,
    } = this.props;
    const { shopHitsData, categoryHitsData, totalNumberOfHits } = this.state;
    const layout = 'layout' in searchPageData && searchPageData.layout ? searchPageData.layout : [];

    const content = (
      <div>
        <SearchResultsContainer
          shopHits={shopHitsData}
          categoryHits={categoryHitsData}
          searchNavBarData={searchNavBarData}
          searchPageData={searchPageData}
          totalNumberOfHits={totalNumberOfHits}
          searchQuery={searchQuery}
          locale={locale}
          userData={userData}
          pageStateModifiers={pageStateModifiers}
        />
        <RenderLayoutViews
          views={layout}
          locale={locale}
          userData={userData}
          pageStateModifiers={pageStateModifiers}
        />
      </div>
    );

    return (
      <MediaQueryHelper
        desktopChildren={<SearchPageContainerDiv>{content}</SearchPageContainerDiv>}
        mobileChildren={<MobileSearchPageContainerDiv>{content}</MobileSearchPageContainerDiv>}
      />
    );
  }
}

export default SearchContent;
